import { useCallback, useEffect, useRef, useState } from "react";
import { enqueueSnackbar } from "notistack";
import { useApiClient } from "../../api";
import { useAuthenticationStore } from "../../stores/auth";
import { introductionOwner } from "./signupPurpose";

export function useOnboardingPreference(user) {
  const api = useApiClient();
  const owner = introductionOwner(user);
  const mounted = useRef(false);
  const busy = useRef(false);
  const [state, setState] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const current = useCallback(
    () =>
      mounted.current &&
      introductionOwner(useAuthenticationStore.getState().user) === owner,
    [owner],
  );
  useEffect(() => {
    mounted.current = true;
    let active = true;
    setLoading(true);
    setState(null);
    api.users
      .getOnboarding()
      .then((value) => {
        if (active && current()) setState(value);
      })
      .catch(() => {
        if (active && current())
          enqueueSnackbar(
            "Getting-started settings could not be loaded. You can still skip for now.",
            { variant: "error" },
          );
      })
      .finally(() => {
        if (active && current()) setLoading(false);
      });
    return () => {
      active = false;
      mounted.current = false;
    };
  }, [api, current]);
  const save = async (variables) => {
    if (!current() || busy.current) return false;
    busy.current = true;
    setSaving(true);
    try {
      const value = await api.users.updateOnboarding(variables);
      if (!current()) return false;
      setState(value);
      return true;
    } catch {
      if (current())
        enqueueSnackbar(
          "Your getting-started choice could not be saved. You can continue and try again later.",
          { variant: "error" },
        );
      return false;
    } finally {
      busy.current = false;
      if (current()) setSaving(false);
    }
  };
  return { state, loading, saving, save, current };
}
